import(/* webpackMode: "eager" */ "/home/runner/workspace/artifacts/light-hero/app/error.tsx");
